import {global, lm} from "../../appContext";
import {nsRoute} from "../../util/route";
import ParsedRouteDataDecorator = nsRoute.ParsedRouteDataDecorator;
import {getHash} from "../../constants/RouteDefinitions";
import policyHtml from './policy.html?raw';

export let template = policyHtml;

export class viewModel extends ParsedRouteDataDecorator {
    private org = global.login.getHomeOrg();
    private user = global.login.user();
    private userProfileLink = this.org && this.user
        ? `#/${this.org.organizationid}/user/${this.user.id}`
        : '#/';

    private getContent() {
        if (!this.org || !this.user) {
            return '';
        }
        const link = `<i class="far fa-link fa-fw"></i> <a href="${getHash('userdetails', {id: this.user.id}, true, this.org.organizationid) ?? '#'}">${lm.t('your profile')}</a>`
        return [
            `privacy statement|link:${link}|homeorgname:${this.org.organizationame}|br`,
            'privacy statementtwo|homeorgname:${this.org.organizationame}|br'
        ].map(str => `<p>${lm.t(str)}</p>`).join('<br>')
    }
}
